



































































































































































































import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class TSampler extends Vue {
  sampler = {
    titleSize: 50, titleLeft: 250, titleTop: 250, titleAlign: "center", descriptionAlign: "center",
    descriptionSize: 20, descriptionLeft: 250, descriptionTop: 250,
    ss1Scale: 1.0, ss1Left: 250, ss1Top: 250,
    ss2Scale: 1.0, ss2Left: 250, ss2Top: 250,
    iconScale: 1.0, iconLeft: 250, iconTop: 250,
  };

  changeSampler() {
    this.$emit("change-tsampler", this.sampler);
  }

  copy() {
    console.log(JSON.stringify(this.sampler));
  }
}
